export const DEFAULT_COLOR = "rgb(128, 128, 128)";
export const LABEL_COLOR = "rgb(51, 51, 51)";
